import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TablePagination from '@mui/material/TablePagination';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Paper from '@mui/material/Paper';

function DetailPayment({
  openDetail,
  setOpenDetail,
  // title,
  // itemname,
  // customerId,
  // invoiceNo,
  // paydate,
  // total,
}) {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpenDetail(true);
  };

  const handleClose = () => {
    setOpenDetail(false);
  };

  return (
    <div>
      {/* <Button
        onClick={handleClickOpen}
        sx={{ color: '#fff' }}
        variant="contained"
      >
        รายละเอียด
      </Button> */}
      <Dialog
        open={openDetail}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="md"
        fullWidth
      >
        {/* <DialogTitle id="alert-dialog-title">test</DialogTitle> */}
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <div className="grid grid-cols-3 gap-4 text-black">
              <div>
                <div>test image</div>
              </div>
              <div className="col-span-2">
                <div className="text-lg">ชื่อเจ้าหนี้</div>
                <div>ชื่อ : </div>
                <div>เลขประจำตัวผู้เสียภาษี : </div>
                <div>เลขที่ใบแจ้งหนี้ : </div>
                <div>วันที่ชำระเงิน : </div>
                <div>จำนวนเงินรวม : </div>
              </div>
            </div>
            <div className="text-black">
              <div className="text-lg">ข้อมูลลูกหนี้</div>
              <div>ชื่อ : </div>
              <div>เลขประจำตัวผู้เสียภาษี : </div>
              <div>เลขที่ใบแจ้งหนี้ : </div>
              <div>วันที่ชำระเงิน : </div>
              <div>จำนวนเงินรวม : </div>
            </div>
            <div className="mt-2 text-black text-lg">รายการใบแจ้งหนี้</div>

            <div className="px-2 py-4">
              <TableContainer component={Paper}>
                <Table aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell>รายการ</TableCell>
                      <TableCell>จำนวน</TableCell>
                      <TableCell>รายการต่อหน่วย</TableCell>
                      <TableCell>รวม</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell>A</TableCell>
                      <TableCell>2</TableCell>
                      <TableCell>100</TableCell>
                      <TableCell>200</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </div>

            {/* Let Google help apps determine location. This means sending
            anonymous location data to Google, even when no apps are running. */}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>กลับ</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default DetailPayment;
